module.exports = __webpack_public_path__ + "static/media/logo.6edf0437.png";